import { parseISO, isValid, isBefore, isAfter } from 'date-fns';

const zipCodeRegex = /^\d{5}$/;

export function parseTimeParam(param?: string | string[]): Date | null {
  let p: string;

  if (!param) return null;

  if (param instanceof Array) [p] = param;
  else p = param;

  const t = parseISO(p);

  if (isValid(t)) return t;
  return null;
}

interface ValidationInput {
  start?: Date | null;
  end?: Date | null;
  zipcode?: string;
  sid?: string;
  distance?: number;
  yearsExperience?: number;
  rate?: number;
}

interface ValidationOutput {
  start?: string;
  end?: string;
  zipcode?: string;
  distance?: string;
  yearsExperience?: string;
  rate?: string;
}

export function validate(params: ValidationInput): ValidationOutput {
  const out: ValidationOutput = {};

  const s = params.start;
  const e = params.end;

  if (s) {
    if (!isValid(s)) out.start = 'Please enter a valid start time';
    else if (isBefore(s, new Date())) out.start = 'Start time cannot be in the past';
  } else if (e && isValid(e)) {
    out.start = 'Please enter a start time';
  }

  if (e && isValid(e)) {
    if (isBefore(e, new Date())) out.end = 'End time cannot be in the past';
    else if (s && isValid(s) && !isAfter(e, s)) out.end = 'End time must be after start time';
  } else if (s && isValid(s)) {
    out.end = 'Please enter an end time';
  }

  if (params.zipcode && !zipCodeRegex.test(params.zipcode)) out.zipcode = 'Please enter a five digit zip code';

  if (params.distance && (params.distance > 50 || params.distance < 1))
    out.distance = 'Please enter a provided option for distance';

  if (params.yearsExperience && params.yearsExperience < 0)
    out.yearsExperience = 'Please enter a positive value for years of experience';

  if (params.rate && params.rate < 0) out.rate = 'Please enter a positive value for rate';

  return out;
}

export default {
  parseTimeParam,
  validate,
};
